import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=98f45b08&scoped=true&"
import script from "./CreateForm.vue?vue&type=script&lang=ts&"
export * from "./CreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=98f45b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f45b08",
  null
  
)

export default component.exports